module.exports = __webpack_public_path__ + "img/cry.d676c5df.png";